import { createPresetPartnerRepaymentCalculator } from './presets/createPresetPartnerRepaymentCalculator.js';
import { createPresetWebsiteFinancingCalculator } from './presets/createPresetWebsiteFinancingCalculator.js';
import { createPresetWebsiteRepaymentCalculator } from './presets/createPresetWebsiteRepaymentCalculator.js';
import { createPresetWebsitePartnerInterestRadar } from './presets/createPresetWebsitePartnerInterestRadar.js';

export const RepaymentCalculatorPresets = {
  createPresetPartnerRepaymentCalculator,
  createPresetWebsiteFinancingCalculator,
  createPresetWebsiteRepaymentCalculator,
  createPresetWebsitePartnerInterestRadar,
};

export type RepaymentCalculatorPresets = typeof RepaymentCalculatorPresets;
